import config from './config';

export default function fixMediaPath(path: string | undefined): string | undefined {
  return path && path.startsWith('~/') ? `${config.kenticoRoot}/${path.substring(1)}` : path;
}
